module.exports = "/assets/data/a97d0b1673ff18f87c5b70761bb80b4d-G5.data.json";